export const hasAnyPermission = (userPermissions, requiredPermissions) => {
  return userPermissions?.some((permission) =>
    requiredPermissions.includes(permission)
  );
};
